import { useEffect, useState } from 'react';
import useInboxStore from '@/stores/InboxStore';
import { MoreVertical, X } from 'lucide-react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';

import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Separator } from '@/components/ui/separator';
import ConversationsList from '@/components/inbox/ConversationList';
import InboxHeader from '@/components/inbox/InboxHeader';

function Inbox() {
  const navigate = useNavigate();
  const { id: routeConversationId } = useParams();

  const { isMultiSelectMode, toggleMultiSelectMode } = useInboxStore(
    useShallow((state) => ({
      isMultiSelectMode: state.isMultiSelectMode,
      toggleMultiSelectMode: state.toggleMultiSelectMode,
    }))
  );

  useEffect(() => {
    console.log('Inbox route ID:', routeConversationId);
  }, [routeConversationId]);

  return (
    <div className='flex h-screen flex-col md:flex-row'>
      <aside
        className={cn(
          'flex flex-col md:border-r',
          'w-full md:w-[300px] lg:w-[380px]',
          routeConversationId ? 'hidden md:flex' : 'flex'
        )}
      >
        <div className='space-y-3 px-3 py-4'>
          <div className='flex items-center justify-between'>
            <h2
              className='w-fit cursor-pointer text-xl font-bold tracking-tight text-primary'
              onClick={() => navigate('/inbox', { replace: true })}
            >
              Inbox
            </h2>
            {isMultiSelectMode ? (
              <Button
                variant='outline'
                size='xs'
                onClick={toggleMultiSelectMode}
              >
                Cancel
              </Button>
            ) : (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant='ghost' size='sm' className='h-8 w-8 p-0'>
                    <MoreVertical className='h-4 w-4' />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align='end'>
                  <DropdownMenuItem onClick={toggleMultiSelectMode}>
                    Select Chats
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            )}
          </div>
          <InboxHeader />
        </div>
        <ConversationsList routeConversationId={routeConversationId} />
      </aside>
      <Separator orientation='vertical' className='hidden md:block' />
      <div
        className={cn(
          'flex-1',
          routeConversationId ? 'block' : 'hidden md:block'
        )}
      >
        <Outlet />
      </div>
    </div>
  );
}

export default Inbox;
